import { Box } from '@planningcenter/tapestry-react';
import React from 'react';
import colors from '../colors.js';

const IndicatorDot = (props) => (React.createElement(Box, { backgroundColor: colors.interaction66, height: 1.5, pointerEvents: "none", position: "absolute", radius: "50%", width: 1.5, zIndex: 6, ...props }));

export { IndicatorDot };
//# sourceMappingURL=indicator_dot.js.map
